import { TraitId } from '@cibo/core'
import { AutocompleteField } from '@cibo/ui'
import { propEq } from 'ramda'

import DETAIL_TEMPLATES from './details/detail_templates.json'

type DetailTemplateFieldProps = {
  traitId: TraitId
  year?: number
  fullWidth?: boolean
}

const optionTest = (option: { label: string }, value: { label: string }) => {
  return value.label === option.label
}

export const DetailTemplateField = ({
  traitId,
  year,
  ...autocompleteProps
}: DetailTemplateFieldProps) => {
  const TEMPLATES = DETAIL_TEMPLATES.filter(propEq('traitId', traitId as string))

  return (
    <AutocompleteField
      {...autocompleteProps}
      name={`${traitId}${year ? `-${year}` : ''}`}
      options={TEMPLATES.map(template => ({ ...template, detail: { ...template.detail, year } }))}
      getOptionLabel={option => option.label}
      selectOnFocus
      isOptionEqualToValue={optionTest}
      popupIcon={null}
    />
  )
}
